import { Button, Col, Modal, Nav, Row, Tab } from "react-bootstrap";
import { Calendar, Mic, MicOff, XCircle } from "react-feather";
import {
  INCIDENT_TYPE,
  SEVERITY,
  TYPE_ACT,
} from "app/shared/constants/GlobalArray";
import React, { Component } from "react";
import { ErrorToast } from "app/shared/components/Popups/ToastMessage";
import AudioPlayer from "react-h5-audio-player";
import CommonDropdown from "./CommonDropdown";
import DatePicker from "react-datepicker";
import LoadingImage from "app/shared/components/Loader/LoadingImage";
import LowSpace from "app/shared/components/Popups/LowSpace";
//import MyDropzone from "app/shared/components/DocumentModal/Dropzone";
import ReportDropZone from "../DocumentModal/ReportDropZone";
import ProjectList from "./ProjectList";
import { ReactMic } from "react-mic";
import CompanyList from "./CompanyList";
import ServiceList from "./ServiceList";
import TimePicker from "react-times";
import Url from "app/shared/constants/Url";
import AsyncSelect from "react-select/async";
import VoiceRecorder from "app/shared/components/VoiceRecorder/VoiceRecorder";
import axios from "axios";
import moment from "moment";
import { requiredMessage } from "app/shared/constants/Messages";
import { withRouter } from "react-router-dom";
import SubmitImage from "../../../../assets/images/submit.png";
import { withTranslation } from "react-i18next";
import { compose } from "redux";
import Axios from "axios";
import FetchEMList from "./services/fetchEMList";

const ErrorMessage = <div className="invalid-feedback">Enter valid name</div>;
const ErrorBlock = ({ message }) => (
  <div className="invalid-feedback">{message || ""}</div>
);
const qs = require("qs");

const DEPT_URL = Url.departmentList;
const CONT_URL = Url.contractorListNew;
const ZONE_URL = Url.zoneList;
const ACT_URL = Url.activitylist;
const Div_URL = Url.divisionList;

const _getDb = () => {
  const hostname = window.location.hostname.toLowerCase();

  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return "stageclide";
  }

  if (hostname.endsWith(".clideanalyser.in")) {
    const db = hostname.replace(".clideanalyser.in", "").trim();

    if (db === "qaclide") {
      return "stageclide";
    }

    return db;
  }

  return hostname.split(".")[0] || "stageclide";
};

const customSelectStyles = {
  control: (base, state) => ({
    ...base,
    width: "100%",
    minHeight: "32px",
    maxHeight: "32px",
    border: "1px solid #E6E6E6",
    borderRadius: "6px",
    boxShadow: "none",
    "&:hover": {
      border: "1px solid #FF5A36",
    },
    backgroundColor: state.isDisabled ? "#F9F9F9" : "white",
    cursor: state.isDisabled ? "not-allowed" : "pointer",
    opacity: state.isDisabled ? 0.7 : 1,
  }),
  valueContainer: (base) => ({
    ...base,
    padding: "0 12px",
    height: "32px",
  }),
  input: (base) => ({
    ...base,
    margin: 0,
    padding: 0,
    color: "#444444",
  }),
  placeholder: (base) => ({
    ...base,
    color: "#999",
    fontSize: "16px",
  }),
  multiValue: (base) => ({
    ...base,
    backgroundColor: "#FFE5E0",
    borderRadius: "4px",
  }),
  multiValueLabel: (base) => ({
    ...base,
    color: "#444444",
    fontSize: "13px",
  }),
  multiValueRemove: (base) => ({
    ...base,
    color: "#FF5A36",
    "&:hover": {
      backgroundColor: "#FF5A36",
      color: "white",
    },
  }),
  singleValue: (base) => ({
    ...base,
    color: "#444444",
    fontSize: "16px",
  }),
  menu: (base) => ({
    ...base,
    width: "100%",
    zIndex: 9999,
    borderRadius: "6px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? "#FF5A36"
      : state.isFocused
        ? "#FFE5E0"
        : "white",
    color: state.isSelected ? "white" : "#444444",
    cursor: "pointer",
    padding: "10px 12px",
    fontSize: "14px",
    "&:active": {
      backgroundColor: "#FF5A36",
    },
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    color: "#999",
    padding: "0 8px",
    "&:hover": {
      color: "#FF5A36",
    },
  }),
  clearIndicator: (base) => ({
    ...base,
    color: "#999",
    padding: "0 8px",
    "&:hover": {
      color: "#FF5A36",
    },
  }),
};
class GPReport extends Component {
  constructor(props) {
    super(props);
    const { t } = this.props;
    this.state = {
      formHideField: this.props.hideFieldList,
      reportType: this.props.reportType,
      tempFiles: [],
      serviceList: [],
      projectList: [],
      departmentList: [],
      contractorList: [],
      zoneList: [],
      divisionList: [],
      locationList: [],
      userData: JSON.parse(localStorage.getItem("userData")),
      typeActList: TYPE_ACT,
      typeIncidentList: INCIDENT_TYPE,
      activityList: [],
      severityList: SEVERITY,
      barrierList: [],
      hazardList: [],
      subHazardList: [],
      searchFiledUsers: [],
      categoryList: [],
      selectedCategory: null,
      categoryError: false,
      voilatorPersonList: [],
      voilatorPersonName: "",
      voilatorId: "",
      voilatorIdList: [],
      observationText: "",
      evidenceFileList: [],
      evidenceUrlList: [],
      selectedCompanyId: null,
      selectedServiceId: null,
      selectedProjectId: null,
      selectedDepartmentId: null,
      selectedContractorId: null,
      selectedZoneId: null,
      selectedLocationId: null,
      selectedTypeAct: null,
      selectedActivity: null,
      selectedSeverity: null,
      selectedBarrier: null,
      selectedHazardId: null,
      selectedSubHazardId: null,
      selectedIncidentTypeId: 1,
      selectedTargetDate: new Date(),
      maxDatepickerDate: new Date(),
      controlMeasure: "",
      resolveCheckbox: false,

      selectedIncidentDate: new Date(),
      selectedIncidentTime: "10:00",
      selectedTimeMeridiem: "AM",
      personName: "",
      personNameList: [],
      lat: 0,
      long: 0,
      observationError: false,
      companyError: false,
      serviceError: false,
      projectError: false,
      projectError: false,

      zoneError: false,
      departmentError: false,
      contractorError: false,
      locationError: false,

      typeActError: false,
      activityError: false,
      severityError: false,
      barrierError: false,
      hazardError: false,
      incidentTypeError: false,
      showRecorderModal: false,
      recordAudio: false,
      controlMeasureAudio: "",
      controlMeasureURL: "",
      observationAudio: "",
      observationURL: "",
      recordingFor: "observation",
      sucesssPopup: false,
      reportNumber: null,
      lowStorageMessage: "",
      lowStorageStatus: 200,
      showLowStoragePopup: false,
      showContractorDropdown: true,
      showZoneDropdown: true,
      showLocationDropdown: true,
      selectedFile: "",
      organisationSetting: false,
      companyList: [],
      projectAutoFill: {
        projectCategory: "",
        projectCategoryId: "",
        region: "",
        state: "",
        city: "",
      },
      selectedSubActivity: null,
      subActivityError: false,
      subActivityList: [],
    };
  }

  _fetchOrganisationSetting = async () => {
    try {
      const response = await axios.get(Url.organisationSettingByDb, {
        params: { db: _getDb() },
      });

      const enabled = !!response?.data?.data?.organisationSetting;

      this.setState({ organisationSetting: enabled });

      return enabled;
    } catch (error) {
      this.setState({ organisationSetting: true });
      return true; // fallback
    }
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.hideFieldList !== prevState.formHideField) {
      return nextProps.hideFieldList;
    }
    return null;
  }

  _closeSuccessPopup = async () => {
    await this.setState({ sucesssPopup: false });
    await this._clearForm();
    this.props.close();
    this.props.history.push("/");
  };

  _continueReporting = async () => {
    await this.setState({ sucesssPopup: false });
    await this._continueReportingClearForm();
    if (!this.state.organisationSetting) {
      await this._fetchServiceList();
    }

    await this._fetchCategoryList();
  };

  _getLocation = async () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.setState((prevState) => {
          let { lat, long } = prevState;
          lat = position.coords.latitude;
          long = position.coords.longitude;
          return { lat, long };
        });
      });
    }
  };

  componentDidMount = async () => {
    const organisationSetting = await this._fetchOrganisationSetting();
    if (organisationSetting) {
      await this._fetchCompanyList();
    } else {
      await this._fetchServiceList();
    }

    await this._getLocation();
    await this._fetchCategoryList();
    this.props.setClick(this._submitGoodPractice);
    this._fetchParamList();
  };

  _fetchCompanyList = async () => {
    let params = {
      page: 0,
      size: 200,
      search: "",
      softdelete: 0,
      softDelete: 0,
    };
    import("app/shared/utility/UtilFunction").then((utilFunction) => {
      let responseObj = utilFunction.sharedAxiosAPIGet(Url.companyList, params);

      responseObj
        .then(async (response) => {
          if (response.data.status === 200) {
            await this.setState((prevState) => {
              let { companyList } = prevState;
              companyList = response.data.data;
              return { companyList };
            });

            if (this.state.userData.designation_flag === 4) {
              this.setState(
                {
                  selectedCompanyId: response.data.data[0]["companyId"],
                },
                () =>
                  void this._fetchServiceList(
                    response.data.data[0]["companyId"],
                  ),
              );
            }

            this._setDataLoading(false);
          }
        })
        .catch((error) => {
          this._setDataLoading(false);
        });
    });
  };

  _fetchParamList = async () => {
    try {
      const userId = localStorage.getItem("userId");
      const token = localStorage.getItem("springToken");

      let requestData = {
        auth_key: token,
        user_id: userId,
      };
      const headers = {
        "Content-Type": "application/json",
      };

      const url = Url.goodPractices.gasavedformsetting;
      const response = await Axios.get(url, { params: requestData, headers });

      if (response.data.status === 200) {
        this._setDataLoading(false);

        const transformedData = response.data.data.reduce((acc, item) => {
          // Convert parameter to camelCase
          let camelCaseKey = item.parameter
            .toLowerCase()
            .replace(/[^a-zA-Z0-9]+(.)/g, (match, chr) => chr.toUpperCase());

          // Assign boolean value based on `value`
          if (item.parameter === "Evidence_limit") {
            // If parameter is Evidence_limit, store its numeric value
            acc[camelCaseKey] = Number(item.value);
          } else {
            // Otherwise store boolean as before
            acc[camelCaseKey] = item.value === 1;
          }
          return acc;
        }, {});

        console.log(transformedData);

        await this.setState(
          (prevState) => {
            let { param_list, dataLoading } = prevState;
            param_list = transformedData;
            dataLoading = false;
            return { param_list, dataLoading };
          },
          async () => {
            await this._fetchOptionList();
          },
        );
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      this._setDataLoading(false);
    }
  };

  _fetchOptionList = async () => {
    const tempUserId = localStorage.getItem("userId");
    const tempToken = localStorage.getItem("token");
    const tempSpringToken = localStorage.getItem("springToken");

    let requestData = {
      auth_key: tempToken,
      user_id: tempUserId,
      service_id: this.state.selectedServiceId,
      project_id: this.state.selectedProjectId,
    };

    var ContentType = {
      "Content-Type": "application/x-www-form-urlencoded",
    };

    if (this.state.userData?.div_dept == 0) this._fetchDepartmentList();

    axios
      .all([
        // Department list
        // axios.post(DEPT_URL, qs.stringify(requestData), {
        //   headers: ContentType,
        // }),
        // Contractor List
        axios.post(
          CONT_URL,
          qs.stringify({ ...requestData, auth_key: tempSpringToken }),
          {
            headers: ContentType,
          },
        ),
        // Zone List
        axios.post(ZONE_URL, qs.stringify(requestData), {
          headers: ContentType,
        }),
        // Activity List
        axios.post(ACT_URL, qs.stringify(requestData), {
          headers: ContentType,
        }),
        //division list
        axios.post(
          Div_URL,
          qs.stringify({ ...requestData, auth_key: tempSpringToken }),
          {
            headers: ContentType,
          },
        ),
      ])
      .then(
        axios.spread(async (contractor, zone, activity, division) => {
          await this.setState((prevState) => {
            let {
              contractorList,
              // departmentList,
              zoneList,
              hazardList,
              activityList,
              barrierList,
              divisionList,
              dataLoading,
            } = prevState;

            // departmentList =
            //   department.data.status === 200 ? department.data?.data : [];
            contractorList =
              contractor.data.status === 200 ? contractor.data?.data : [];
            zoneList = zone.data.status === 200 ? zone.data?.data : [];

            activityList =
              activity.data.status === 200 ? activity.data?.data : [];

            divisionList =
              division.data.status === 200 ? division.data.data : [];

            dataLoading = false;

            return {
              contractorList,
              // departmentList,
              zoneList,
              hazardList,
              activityList,
              barrierList,
              divisionList,
              dataLoading,
            };
          });
        }),
      )
      .catch((error) => {
        this._setDataLoading(false);
      });
  };

  _setDataLoading = async (status) => {
    await this.setState((prevState) => {
      let { dataLoading } = prevState;
      dataLoading = status;
      return { dataLoading };
    });
  };

  _fetchServiceList = async (companyId = null) => {
    import("app/shared/utility/UtilFunction").then((utilFunction) => {
      let responseObj = utilFunction.sharedAxiosAPI(
        Url.serviceList,
        { "Content-Type": "application/x-www-form-urlencoded" },
        { company_id: companyId },
      );

      responseObj
        .then(async (response) => {
          if (response.data.status === 200) {
            await this.setState((prevState) => {
              let { serviceList } = prevState;
              serviceList = response.data.data;
              return { serviceList };
            });
            if (this.state.userData.designation_flag === 4) {
              this.setState(
                {
                  selectedServiceId: response.data.data[0]["service_id"],
                },
                () =>
                  void this._fetchProjectList(
                    response.data.data[0]["service_id"],
                  ),
              );
            }
            this._setDataLoading(false);
          }
        })
        .catch((error) => {
          this._setDataLoading(false);
        });
    });
  };

  _companyChangeHandle = async (companyId) => {
    await this.setState((prevState) => {
      let { selectedCompanyId, companyError } = prevState;
      selectedCompanyId = companyId;
      companyError = companyId ? false : true;
      return { selectedCompanyId, companyError };
    });
    this.setState({ selectedServiceId: null, serviceList: [] });
    await this._resetDropdwon();

    if (companyId) {
      this._fetchServiceList(companyId);
    }
  };

  _serviceChangeHandle = async (serviceId) => {
    await this.setState((prevState) => {
      let { selectedServiceId, serviceError } = prevState;
      selectedServiceId = serviceId;
      serviceError = serviceId ? false : true;
      return { selectedServiceId, serviceError };
    });
    await this._resetDropdwon();
    this._fetchProjectList(serviceId);
  };

  _resetDropdwon = async (projectReset = true) => {
    await this.setState((prevState) => {
      let {
        selectedHazardId,
        selectedSubHazardId,
        selectedProjectId,
        selectedContractorId,
        selectedDepartmentId,
        selectedActivity,
        selectedLocationId,
        selectedZoneId,
        selectedBarrier,
        hazardList,
        subHazardList,
        projectList,
        contractorList,
        departmentList,
        activityList,
        locationList,
        barrierList,
        zoneList,
      } = prevState;

      if (projectReset) {
        selectedProjectId = null;
        projectList = [];
      }

      selectedHazardId = null;
      selectedSubHazardId = null;
      selectedContractorId = null;
      selectedActivity = null;
      selectedLocationId = null;
      selectedBarrier = null;
      selectedDepartmentId = null;
      selectedZoneId = null;

      hazardList = [];
      subHazardList = [];
      departmentList = [];
      contractorList = [];
      locationList = [];
      barrierList = [];
      activityList = [];
      zoneList = [];

      return {
        selectedHazardId,
        selectedProjectId,
        selectedSubHazardId,
        selectedContractorId,
        selectedDepartmentId,
        selectedActivity,
        selectedLocationId,
        selectedZoneId,
        selectedBarrier,
        hazardList,
        subHazardList,
        projectList,
        contractorList,
        departmentList,
        activityList,
        locationList,
        barrierList,
        zoneList,
      };
    });
  };

  _fetchProjectList = async (serviceId) => {
    let requestData = {
      service_id: serviceId,
      module_name: "Good Acts",
    };

    var ContentType = {
      "Content-Type": "application/x-www-form-urlencoded",
    };

    import("app/shared/utility/UtilFunction").then((utilFunction) => {
      let responseObj = utilFunction.sharedAxiosAPI(
        Url.projectListForm,
        ContentType,
        requestData,
      );

      responseObj
        .then(async (response) => {
          if (response.data.status === 200) {
            await this.setState((prevState) => {
              let { projectList } = prevState;
              projectList = response.data.data;
              return { projectList };
            });
            if (this.state.userData.designation_flag === 4) {
              const project = response.data.data[0];

              const { project_id, contractor_flag, zone_location_flag } =
                project;
              this.setState(
                {
                  selectedProjectId: project_id,
                  showContractorDropdown: Boolean(contractor_flag),
                  showLocationDropdown: Boolean(zone_location_flag),
                  showZoneDropdown: Boolean(zone_location_flag),

                  ...(this.state.organisationSetting
                    ? {
                        projectAutoFill: {
                          projectCategory: project.project_category ?? "",
                          projectCategoryId:
                            project.project_category_id ??
                            project.projectCategoryId ??
                            project.project_category ??
                            "",
                          region: project.region ?? "",
                          state: project.state ?? "",
                          city: project.city ?? "",
                        },
                      }
                    : {}),
                },
                () => {
                  this._fetchOptionList();
                  this._fetchParamList();
                },
              );
            }
          }
        })
        .catch((error) => {
          this._setDataLoading(false);
        });
    });
  };

  _projectChangeHandle = async (projectId) => {
    const project = this.state.projectList.find(
      (data) => data.project_id == projectId,
    );

    await this._resetDropdwon(false);

    this.setState((prevState) => {
      let {
        selectedProjectId,
        projectError,
        showContractorDropdown,
        showZoneDropdown,
        showLocationDropdown,
        projectList,
      } = prevState;

      // check contractor flag
      let index = projectList.findIndex((item) => projectId == item.project_id);
      const isContractor = projectList[index].contractor_flag;
      showContractorDropdown = isContractor == 0 ? false : true;

      const isZone = projectList[index].zone_location_flag;
      showZoneDropdown = isZone == 0 ? false : true;

      const isLocation = projectList[index].zone_location_flag;
      showLocationDropdown = isLocation == 0 ? false : true;

      selectedProjectId = projectId;
      projectError = projectId ? false : true;

      return {
        selectedProjectId,
        projectError,
        showContractorDropdown,
        showZoneDropdown,
        showLocationDropdown,
      };
    });

    // Org setting ON → auto-fill Project Details from the selected project
    if (this.state.organisationSetting && project) {
      this.setState({
        projectAutoFill: {
          projectCategory: project.project_category ?? "",
          // projectlistform returns project_category as a string; use the id field if present
          projectCategoryId:
            project.project_category_id ??
            project.projectCategoryId ??
            project.project_category ??
            "",
          region: project.region ?? "",
          state: project.state ?? "",
          city: project.city ?? "",
        },
      });
    }
    await this._fetchOptionList();
  };

  _zoneChangeHandle = async (zoneId) => {
    await this.setState((prevState) => {
      let {
        selectedZoneId,
        departmentError,
        contractorError,
        // locationError,
        zoneError,
      } = prevState;
      selectedZoneId = zoneId;
      zoneError = zoneId ? false : true;

      const isFieldShownMapAndValid = {
        isValidDepartment: !!selectedZoneId,
        isValidContactor: !!selectedZoneId,
        // isValidLocation: !!selectedZoneId,
        isValidZone: !!selectedZoneId,

        isShownDepartment: !Object.values(prevState.formHideField).includes(
          "Department",
        ),
        isShownContactor: prevState.showContractorDropdown,
        // isShownLocation: prevState.showLocationDropdown,
        isShownZone: prevState.showZoneDropdown,
      };

      if (isFieldShownMapAndValid.isShownDepartment) {
        departmentError = !selectedZoneId;
      }

      if (isFieldShownMapAndValid.isShownContactor) {
        contractorError = !selectedZoneId;
      }

      // if (isFieldShownMapAndValid.isShownLocation) {
      //   locationError = !selectedZoneId;
      // }
      return {
        selectedZoneId,
        departmentError,
        contractorError,
        // locationError,
        zoneError,
      };
    });
    await this._fetchLocationList();
  };

  _fetchLocationList = async (zoneId) => {
    const userId = localStorage.getItem("userId");
    const token = localStorage.getItem("token");

    let requestData = {
      auth_key: token,
      user_id: userId,
      service_id: this.state.selectedServiceId,
      project_id: this.state.selectedProjectId,
      zone_id: this.state.selectedZoneId,
    };
    var ContentType = {
      "Content-Type": "application/x-www-form-urlencoded",
    };

    import("app/shared/utility/UtilFunction").then((utilFunction) => {
      let responseObj = utilFunction.sharedAxiosAPI(
        Url.locationList,
        ContentType,
        requestData,
      );

      responseObj
        .then(async (response) => {
          if (response.data.status === 200) {
            await this.setState((prevState) => {
              let { locationList } = prevState;
              locationList = response.data.data;
              return { locationList };
            });
          }
        })
        .catch((error) => {
          this._setDataLoading(false);
        });
    });
  };

  _fetchCategoryList = async (zoneId) => {
    const userId = localStorage.getItem("userId");
    const token = localStorage.getItem("springToken");

    let requestData = {
      auth_key: token,
      user_id: userId,
    };
    var ContentType = {
      "Content-Type": "application/x-www-form-urlencoded",
    };

    import("app/shared/utility/UtilFunction").then((utilFunction) => {
      let responseObj = utilFunction.sharedAxiosAPISpringWithoutParam(
        Url.goodPractices.categoryList,
        ContentType,
        // requestData
      );

      responseObj
        .then(async (response) => {
          if (response.data.status === 200) {
            await this.setState((prevState) => {
              let { categoryList } = prevState;
              categoryList = response.data?.data?.category_list || [];
              return { categoryList };
            });
          }
        })
        .catch((error) => {
          this._setDataLoading(false);
        });
    });
  };

  _divisionChangeHandle = async (id) => {
    await this.setState((prevState) => {
      let { selectedDivisionId, divisionError } = prevState;
      selectedDivisionId = id;
      divisionError = id ? false : true;
      return { selectedDivisionId, divisionError };
    });
    await this._fetchDepartmentList();
  };

  _fetchDepartmentList = async () => {
    let requestData = {
      service_id: this.state.selectedServiceId,
      project_id: this.state.selectedProjectId,
      divisionId: this.state.selectedDivisionId,
      // zone_id: zoneId,
    };
    var ContentType = {
      "Content-Type": "application/x-www-form-urlencoded",
    };

    import("app/shared/utility/UtilFunction").then((utilFunction) => {
      let responseObj = utilFunction.sharedAxiosAPISpring(
        DEPT_URL,
        ContentType,
        requestData,
      );

      responseObj
        .then(async (response) => {
          if (response.data.status === 200) {
            await this.setState((prevState) => {
              let { departmentList } = prevState;
              departmentList = response.data.data;
              return { departmentList };
            });
          }
        })
        .catch((error) => {
          this._setDataLoading(false);
        });
    });
  };

  _fetchSubHazardList = async () => {
    const userId = localStorage.getItem("userId");
    const token = localStorage.getItem("token");
    let requestData = {
      auth_key: token,
      user_id: userId,
      hazard_Id: this.state.selectedHazardId,
    };
    var ContentType = {
      "Content-Type": "application/x-www-form-urlencoded",
    };

    import("app/shared/utility/UtilFunction").then((utilFunction) => {
      let responseObj = utilFunction.sharedAxiosAPI(
        Url.subhazardList,
        ContentType,
        requestData,
      );

      responseObj
        .then(async (response) => {
          if (response.data.status === 200) {
            await this.setState((prevState) => {
              let { subHazardList } = prevState;
              subHazardList = response.data.data;
              return { subHazardList };
            });
          }
        })
        .catch((error) => {
          this._setDataLoading(false);
        });
    });
  };

  _hazardChangeHandle = async (hazardId) => {
    await this.setState((prevState) => {
      let { selectedHazardId, hazardError } = prevState;
      selectedHazardId = hazardId;

      if (this.state.reportType === "soi") {
        hazardError = hazardId ? false : true;
      }

      return { selectedHazardId, hazardError };
    });
    await this._fetchSubHazardList();
  };

  _departmentChangeHandle = async (id) => {
    await this.setState((prevState) => {
      let {
        selectedDepartmentId,
        departmentError,
        contractorError,
        locationError,
        zoneError,
      } = prevState;
      selectedDepartmentId = id;
      departmentError = id ? false : true;
      const isFieldShownMapAndValid = {
        isValidDepartment: !!selectedDepartmentId,
        isValidContactor: !!selectedDepartmentId,
        isValidLocation: !!selectedDepartmentId,
        isValidZone: !!selectedDepartmentId,

        isShownDepartment: !Object.values(prevState.formHideField).includes(
          "Department",
        ),
        isShownContactor: prevState.showContractorDropdown,
        isShownLocation: prevState.showLocationDropdown,
        isShownZone: prevState.showZoneDropdown,
      };

      if (isFieldShownMapAndValid.isShownDepartment) {
        departmentError = !selectedDepartmentId;
      }

      if (isFieldShownMapAndValid.isShownContactor) {
        contractorError = !selectedDepartmentId;
      }

      if (
        isFieldShownMapAndValid.isShownLocation &&
        isFieldShownMapAndValid.isShownZone
      ) {
        locationError = !selectedDepartmentId;
        zoneError = !selectedDepartmentId;
      }

      return {
        selectedDepartmentId,
        departmentError,
        contractorError,
        locationError,
        zoneError,
      };
    });
  };

  _locationChangeHandle = async (id) => {
    this.setState((prevState) => {
      let {
        selectedLocationId,
        departmentError,
        contractorError,
        locationError,
      } = prevState;
      selectedLocationId = id;
      locationError = id ? false : true;

      const isFieldShownMapAndValid = {
        isValidDepartment: !!selectedLocationId,
        isValidContactor: !!selectedLocationId,
        isValidLocation: !!selectedLocationId,
        isValidZone: !!selectedLocationId,

        isShownDepartment: !Object.values(prevState.formHideField).includes(
          "Department",
        ),
        isShownContactor: prevState.showContractorDropdown,
        isShownLocation: prevState.showLocationDropdown,
        isShownZone: prevState.showZoneDropdown,
      };

      if (isFieldShownMapAndValid.isShownDepartment) {
        // departmentError = !prevState.selectedDepartmentId;
        departmentError = !selectedLocationId;
      }

      if (isFieldShownMapAndValid.isShownContactor) {
        // contractorError = !prevState.selectedContractorId;
        contractorError = !selectedLocationId;
      }

      return {
        selectedLocationId,
        locationError,
        departmentError,
        contractorError,
      };
    });
  };

  _subHazardChangeHandle = async (id) => {
    await this.setState((prevState) => {
      let { selectedSubHazardId } = prevState;
      selectedSubHazardId = id;
      //subHazardError = id ? false : true;
      return { selectedSubHazardId };
    });
  };

  _barrierChangeHandle = async (id) => {
    await this.setState((prevState) => {
      let { selectedBarrier, barrierError } = prevState;
      selectedBarrier = id;

      if (this.state.reportType === "soi") {
        barrierError = id ? false : true;
      }

      return { selectedBarrier, barrierError };
    });
  };

  // Fetch the risk-register tree for an activity and seed the dropdowns.
  _fetchRiskRegisterByActivity = async (activityId) => {
    const userId = localStorage.getItem("userId");
    const token = localStorage.getItem("springToken");
    try {
      const response = await axios.get(Url.riskRegisterByActivity, {
        params: { user_id: userId, auth_key: token, activityId },
        headers: { accept: "application/json" },
      });
      const data = response?.data?.data || null;
      const subActivities = data?.subActivities || [];
      this.setState({
        riskRegisterTree: data,
        subActivityList: subActivities.map((sa) => ({
          name: sa.sub_activity_name || sa.subActivityName || sa.name || "",
          id: sa.sub_activity_id || sa.subActivityId || sa.id || 0,
        })),
        selectedSubActivity: null,
        subActivityError: false,
      });
    } catch (error) {
      this.setState({
        riskRegisterTree: null,
        subActivityList: [],
        hazardList: [],
      });
    }
  };

  _activityChangeHandle = async (id) => {
    await this.setState((prevState) => {
      let { selectedActivity, activityError } = prevState;
      selectedActivity = id;
      activityError = id ? false : true;
      return { selectedActivity, activityError };
    });

    // organisation setting ON → drive the cascade from the risk register tree
    if (this.state.organisationSetting) {
      await this._fetchRiskRegisterByActivity(id);
      return;
    }
  };

  _subActivityChangeHandle = async (id) => {
    await this.setState((prevState) => {
      let { selectedSubActivity, subActivityError } = prevState;
      selectedSubActivity = id;
      subActivityError = id ? false : true;
      return { selectedSubActivity, subActivityError };
    });
  };

  _categoryChangeHandle = async (id) => {
    await this.setState((prevState) => {
      let { selectedCategory, categoryError } = prevState;
      selectedCategory = id;
      categoryError = id ? false : true;
      return { selectedCategory, categoryError };
    });
  };

  _contractorChangeHandle = async (id) => {
    await this.setState((prevState) => {
      let {
        selectedContractorId,
        departmentError,
        contractorError,
        locationError,
        zoneError,
      } = prevState;
      selectedContractorId = id;
      contractorError = id ? false : true;

      const isFieldShownMapAndValid = {
        isValidDepartment: !!selectedContractorId,
        isValidContactor: !!selectedContractorId,
        isValidLocation: !!selectedContractorId,
        isValidZone: !!selectedContractorId,

        isShownDepartment: !Object.values(prevState.formHideField).includes(
          "Department",
        ),
        isShownContactor: prevState.showContractorDropdown,
        isShownLocation: prevState.showLocationDropdown,
        isShownZone: prevState.showZoneDropdown,
      };

      if (isFieldShownMapAndValid.isShownDepartment) {
        departmentError = !selectedContractorId;
      }

      if (isFieldShownMapAndValid.isShownContactor) {
        contractorError = !selectedContractorId;
      }

      if (
        isFieldShownMapAndValid.isShownLocation &&
        isFieldShownMapAndValid.isShownZone
      ) {
        locationError = !selectedContractorId;
        zoneError = !selectedContractorId;
      }
      return {
        selectedContractorId,
        departmentError,
        contractorError,
        locationError,
        zoneError,
      };
    });
  };

  _severityChangeHandle = async (id) => {
    await this.setState((prevState) => {
      let { selectedSeverity, severityError } = prevState;
      selectedSeverity = id;
      severityError = id ? false : true;
      return { selectedSeverity, severityError };
    });
  };

  _typeactChangeHandle = async (id) => {
    await this.setState((prevState) => {
      let { selectedTypeAct, typeActError } = prevState;
      selectedTypeAct = id;
      typeActError = id ? false : true;
      return { selectedTypeAct, typeActError };
    });
  };

  _typeIncidentChangeHandle = async (id) => {
    await this.setState((prevState) => {
      let { selectedIncidentTypeId, incidentTypeError } = prevState;
      selectedIncidentTypeId = id;
      incidentTypeError = id ? false : true;
      return { selectedIncidentTypeId, incidentTypeError };
    });
  };

  _evidenceFileHandle = async (event) => {
    var evidence_file = Array.from(event.target.files);
    event.target.value = "";

    const lowStorage = this.checkLowStorage();

    lowStorage
      .then(async (response) => {
        const { status, msg } = response.data;

        if (status == 200) {
          var tempUrl = [];
          var filePromise = new Promise((resolve, reject) => {
            evidence_file.forEach((item, index) => {
              let temVar;

              let reader = new FileReader();
              reader.readAsDataURL(item);
              reader.onloadend = () => {
                tempUrl.push(reader.result);
                if (index === evidence_file.length - 1) {
                  return resolve(1);
                }
              };
            });
          });

          filePromise.then(async () => {
            await this.setState((prevState) => {
              let { evidenceFileList, evidenceUrlList } = prevState;
              const tempArr = evidence_file.map((item) => item);
              evidenceFileList = [...evidenceFileList, ...tempArr];
              evidenceUrlList = [...evidenceUrlList, ...tempUrl];
              return { evidenceFileList, evidenceUrlList };
            });
          });
        }
        await this.setState({
          lowStorageStatus: status,
          lowStorageMessage: msg,
          showLowStoragePopup: status == 200 ? false : true,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  _handleChange = async (item = null, type = "observation") => {
    await this.setState((prevState) => {
      switch (type) {
        case "observation":
          let { observationText, observationError, observationURL } = prevState;
          observationText = item;
          observationError = !observationURL && !item ? true : false;
          return { observationText, observationError };
          break;

        case "person_name":
          let { personName, personNameError } = prevState;
          personName = item;
          personNameError = item ? false : true;
          return { personName, personNameError };
          break;

        default:
          return prevState;
          break;
      }
    });
  };

  _removePreviewFile = async (index = 0) => {
    await this.setState((prevState) => {
      let { evidenceFileList, evidenceUrlList } = prevState;
      evidenceFileList.splice(index, 1);
      evidenceUrlList.splice(index, 1);
      return { evidenceFileList, evidenceUrlList };
    });
  };

  checkLowStorage = () => {
    return import("app/shared/utility/UtilFunction").then((utilFunction) => {
      let responseObj = utilFunction.sharedAxiosAPI(
        Url.reportSetting.checkStorage,
      );

      return responseObj;
    });
  };

  _handleLowSpace = async (statusFlag) => {
    await this.setState({ showLowStoragePopup: false });
  };

  searchActiveUser = async (inputString, callback) => {
    // const contentType = { "Content-Type": "application/x-www-form-urlencoded" };
    let userId = localStorage.getItem("userId");
    let token = localStorage.getItem("springToken");
    const requestParams = {
      auth_key: token,
      user_id: userId,
      search: inputString,
    };
    await axios
      .get(Url.userSearch, {
        params: requestParams,
        headers: {
          accept: "application/json",
        },
      })
      .then(async (response) => {
        if (response.data.status === 200) {
          callback(response.data);
          await this.setState({
            searchData: { ...this.state.searchData, ...response.data },
          });
        }
      })
      .catch((error) => {});
  };

  _formValidation = async () => {
    const tempObj = this.state;

    await this.setState((prevState) => {
      prevState.observationError =
        tempObj.observationText || tempObj.observationURL ? false : true;

      if (this.state.organisationSetting) {
        prevState.companyErrorError = tempObj.selectedCompanyId ? false : true;
      }
      prevState.serviceError = tempObj.selectedServiceId ? false : true;

      prevState.projectError = tempObj.selectedProjectId ? false : true;

      if (
        this.state.param_list?.subActivity &&
        this.state.subActivityList.length > 0
      ) {
        prevState.subActivityError = tempObj.selectedSubActivity ? false : true;
      } else {
        prevState.subActivityError = false;
      }

      // DEPARTMENT/LOCATION/CONTRACTOR/ZONE validation START
      const isFieldShownMapAndValid = {
        isValidDepartment: !!tempObj.selectedDepartmentId,
        isValidContactor: !!tempObj.selectedContractorId,
        isValidLocation: !!tempObj.selectedLocationId,
        isValidZone: !!tempObj.selectedZoneId,

        isShownDepartment: !Object.values(this.state.formHideField).includes(
          "Department",
        ),
        isShownContactor: this.state.showContractorDropdown,
        isShownLocation: this.state.showLocationDropdown,
        isShownZone: this.state.showZoneDropdown,
      };

      if (
        isFieldShownMapAndValid.isShownDepartment &&
        isFieldShownMapAndValid.isShownContactor &&
        isFieldShownMapAndValid.isShownLocation &&
        isFieldShownMapAndValid.isShownZone
      ) {
        // dept, contractor, location
        if (isFieldShownMapAndValid.isValidDepartment) {
          prevState.departmentError =
            !isFieldShownMapAndValid.isValidDepartment;
          prevState.contractorError = false;
          prevState.locationError = false;
          prevState.zoneError = false;
        } else if (isFieldShownMapAndValid.isValidContactor) {
          prevState.contractorError = !isFieldShownMapAndValid.isValidContactor;
          prevState.departmentError = false;
          prevState.locationError = false;
          prevState.zoneError = false;
        } else if (
          isFieldShownMapAndValid.isValidZone &&
          isFieldShownMapAndValid.isValidLocation
        ) {
          prevState.departmentError = false;
          prevState.contractorError = false;
          prevState.locationError = !isFieldShownMapAndValid.isValidLocation;
          prevState.zoneError = !isFieldShownMapAndValid.isValidZone;
        } else {
          prevState.departmentError = true;
          prevState.contractorError = true;
          prevState.locationError = true;
          prevState.zoneError = true;
        }
      } else if (
        isFieldShownMapAndValid.isShownDepartment &&
        isFieldShownMapAndValid.isShownContactor
      ) {
        // dept, contractor
        if (isFieldShownMapAndValid.isValidDepartment) {
          prevState.departmentError =
            !isFieldShownMapAndValid.isValidDepartment;
          prevState.contractorError = false;
        } else if (isFieldShownMapAndValid.isValidContactor) {
          prevState.contractorError = !isFieldShownMapAndValid.isValidContactor;
          prevState.departmentError = false;
        } else {
          prevState.contractorError = true;
          prevState.departmentError = true;
        }
      } else if (
        isFieldShownMapAndValid.isShownDepartment &&
        isFieldShownMapAndValid.isShownLocation &&
        isFieldShownMapAndValid.isShownZone
      ) {
        // dept, location
        if (isFieldShownMapAndValid.isValidDepartment) {
          prevState.departmentError =
            !isFieldShownMapAndValid.isValidDepartment;
          prevState.locationError = false;
          prevState.zoneError = false;
        } else if (
          isFieldShownMapAndValid.isValidZone &&
          isFieldShownMapAndValid.isValidLocation
        ) {
          prevState.departmentError = false;
          prevState.locationError = !isFieldShownMapAndValid.isValidLocation;
          prevState.zoneError = !isFieldShownMapAndValid.isValidZone;
        } else {
          prevState.departmentError = true;
          prevState.locationError = true;
          prevState.zoneError = true;
        }
      } else if (
        isFieldShownMapAndValid.isShownContactor &&
        isFieldShownMapAndValid.isShownLocation &&
        isFieldShownMapAndValid.isShownZone
      ) {
        // contractor, location
        if (isFieldShownMapAndValid.isValidContactor) {
          prevState.contractorError = !isFieldShownMapAndValid.isValidContactor;
          prevState.departmentError = false;
          prevState.locationError = false;
          prevState.zoneError = false;
        } else if (
          isFieldShownMapAndValid.isValidZone &&
          isFieldShownMapAndValid.isValidLocation
        ) {
          prevState.departmentError = false;
          prevState.contractorError = false;
          prevState.locationError = !isFieldShownMapAndValid.isValidLocation;
          prevState.zoneError = !isFieldShownMapAndValid.isValidZone;
        } else {
          prevState.contractorError = true;
          prevState.locationError = true;
          prevState.zoneError = true;
        }
      } else if (isFieldShownMapAndValid.isShownDepartment) {
        // dept
        prevState.departmentError = !isFieldShownMapAndValid.isValidDepartment;
      } else if (isFieldShownMapAndValid.isShownContactor) {
        // contractor
        prevState.departmentError = !isFieldShownMapAndValid.isValidContactor;
      } else if (
        isFieldShownMapAndValid.isShownLocation &&
        isFieldShownMapAndValid.isShownZone
      ) {
        // location
        prevState.locationError = !isFieldShownMapAndValid.isValidLocation;
        prevState.zoneError = !isFieldShownMapAndValid.isValidZone;
      }
      // DEPARTMENT/LOCATION/CONTRACTOR/ZONE validation END

      prevState.activityError = tempObj.selectedActivity ? false : true;
      prevState.categoryError = tempObj.selectedCategory ? false : true;

      return prevState;
    });
  };

  _uploadFile = async (file) => {
    console.log("Adding file to parent:", file.name);

    if (this.state.tempFiles.length >= this.state?.param_list?.evidenceLimit) {
      ErrorToast(
        "You can not upload more than " +
          this.state?.param_list?.evidenceLimit +
          " files, as per Evidence Limit.",
      );
      return;
    }

    if (file != null) {
      await this.setState((prevState) => {
        let { selectedFile, tempFiles } = prevState;
        selectedFile = file;
        tempFiles = [...tempFiles, file];
        return { selectedFile, tempFiles };
      });
    }
  };

  _removeUploadedFile = async (removedFile) => {
    console.log("Removing file from parent:", removedFile.name);

    await this.setState((prevState) => {
      let { tempFiles } = prevState;

      // Find and remove the file from tempFiles array
      const updatedFiles = tempFiles.filter((existingFile) => {
        // Compare multiple properties to ensure correct file identification
        return !(
          existingFile.name === removedFile.name &&
          existingFile.size === removedFile.size &&
          existingFile.type === removedFile.type &&
          existingFile.lastModified === removedFile.lastModified
        );
      });

      return { tempFiles: updatedFiles };
    });

    console.log("Updated tempFiles count:", this.state.tempFiles.length);
  };

  _submitGoodPractice = async () => {
    await this._formValidation();

    // Checking form have any Error
    let formErrorStatus;
    for (var propertyName in this.state) {
      if (propertyName.includes("Error")) {
        if (this.state[propertyName]) {
          formErrorStatus = true;
          return;
        } else {
          formErrorStatus = false;
        }
      }
    }

    // If form not have error then submit form
    if (!formErrorStatus) {
      // this.props.parentStateSetter(({
      //   apiLoading:true
      // }));
      const userId = localStorage.getItem("userId");
      const token = localStorage.getItem("springToken");

      await this.setState({ dataLoading: true });

      this._setDataLoading(true);

      let soiData = new FormData();
      soiData.append("auth_key", token);
      soiData.append("user_id", userId);
      soiData.append("service_id", this.state.selectedServiceId || 0);
      soiData.append("project_id", this.state.selectedProjectId || 0);

      soiData.append("category", this.state.selectedCategory || 0);

      soiData.append("activity", this.state.selectedActivity || 0);

      if (this.state.organisationSetting) {
        soiData.append("companyId", this.state.selectedCompanyId || 0);
        soiData.append(
          "projectCategory",
          this.state.projectAutoFill.projectCategoryId || "",
        );
        soiData.append("region", this.state.projectAutoFill.region || "");
        soiData.append("state", this.state.projectAutoFill.state || "");
        soiData.append("city", this.state.projectAutoFill.city || "");
      }

      if (this.state.param_list?.subActivity) {
        soiData.append(
          "subActivityId",
          this.state.selectedSubActivity ? this.state.selectedSubActivity : 0,
        );
      }
      let incidentPersons = [];

      if (this.state.searchFiledUsers?.length) {
        const searchFiledUsersData = this.state.searchFiledUsers.map((el) => ({
          incidentPersonId: el.employeeId,
          searchIncidentPersonId: el.incident_person_id,
          incidentPersonName: el?.incident_person_name,
        }));

        incidentPersons = [...incidentPersons, ...searchFiledUsersData];
      }

      if (this.state.searchEmployeeUsers?.length) {
        const searchFiledUsersData = this.state.searchEmployeeUsers.map(
          (el) => ({
            incidentPersonId: el?.clientEmployeeId,
            searchIncidentPersonId: el?.id,
            incidentPersonName: el?.displayName,
          }),
        );

        incidentPersons = [...incidentPersons, ...searchFiledUsersData];
      }

      if (
        this.state.voilatorIdList.length &&
        this.state.voilatorPersonList.length
      ) {
        const violatorData = this.state.voilatorIdList.map((id, index) => ({
          incidentPersonId: id,
          incidentPersonName: this.state.voilatorPersonList[index] || "",
          searchIncidentPersonId: 0,
        }));

        incidentPersons = [...incidentPersons, ...violatorData];
      }

      soiData.append("incidentPersonString", JSON.stringify(incidentPersons));

      soiData.append("person", JSON.stringify(incidentPersons));
      soiData.append("zone", this.state.selectedZoneId || 0);
      soiData.append("location", this.state.selectedLocationId || 0);
      soiData.append("department", this.state.selectedDepartmentId || 0);
      soiData.append("division", this.state.selectedDivisionId || 0);

      soiData.append("contractor", this.state.selectedContractorId || 0);
      soiData.append("observation", this.state.observationText || "");

      soiData.append("lat", this.state.lat);
      soiData.append("lang", this.state.long);
      if (this.state.observationAudio) {
        soiData.append("observation_record", this.state.observationAudio);
      }

      // Evidence File
      if (this.state.tempFiles.length) {
        this.state.tempFiles.forEach((el) => {
          soiData.append("file", el || "");
        });
      }

      soiData.append("fileStatus", this.state.selectedFile ? 1 : 0);

      var ContentType = {
        "Content-Type": "multipart/form-data",
      };

      let URL = Url.goodPractices.addGoodPractice;

      await axios
        .post(URL, soiData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          params: {
            auth_key: token,
            user_id: userId,
          },
        })
        .then(async (response) => {
          this._setDataLoading(false);
          this.setState({
            clearDropZone: true,
          });
          if (response.data.status === 200) {
            await this._continueReportingClearForm();
            await this.setState({
              reportNumber: response.data.report_number,
              sucesssPopup: true,
            });
            await this._continueReportingClearForm();
          } else {
            ErrorToast(response.data?.msg || "Something went wrong!");
          }
        })
        .catch((error) => {
          this._setDataLoading(false);
        });
      // .finally(() =>{
      //   this.props.parentStateSetter(({
      //     apiLoading:false
      //   }));
      // })
    }
  };

  searchClientEmployee = async (inputString, callback) => {
    FetchEMList({ search: inputString })
      .then(async (response) => {
        console.log(response);

        if (response.status === 200) {
          callback(response.data);
          await this.setState({
            searchEmployeeData: {
              ...this.state.searchEmployeeData,
              ...response.data,
            },
          });
        }
      })
      .catch((error) => {});
  };

  _showRecorder = async (flag = false, type = "observation") => {
    if (flag) {
      const lowStorage = this.checkLowStorage();
      lowStorage
        .then(async (response) => {
          const { status, msg } = response.data;

          if (status == 200) {
            await this.setState((prevState) => {
              let { showRecorderModal, recordingFor } = prevState;
              showRecorderModal = flag;
              recordingFor = type;
              return { showRecorderModal, recordingFor };
            });
          }
          await this.setState({
            lowStorageStatus: status,
            lowStorageMessage: msg,
            showLowStoragePopup: status == 200 ? false : true,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      await this.setState((prevState) => {
        let { showRecorderModal, recordingFor } = prevState;
        showRecorderModal = flag;
        recordingFor = type;
        return { showRecorderModal, recordingFor };
      });
    }
  };

  startRecording = async () => {
    await this.setState({ recordAudio: true });
  };

  stopRecording = async () => {
    await this.setState({ recordAudio: false });
  };

  onStop = async (recordedBlob) => {
    let promise = new Promise((resolve, error) => {
      let reader = new FileReader();
      reader.readAsDataURL(recordedBlob.blob);
      reader.onloadend = () => {
        resolve(reader.result);
      };
    });

    promise.then(async (response) => {
      await this.setState((prevState) => {
        let {
          controlMeasureAudio,
          controlMeasureURL,
          observationAudio,
          observationURL,
        } = prevState;
        if (this.state.recordingFor === "control_measure") {
          controlMeasureAudio = recordedBlob.blob;
          controlMeasureURL = response;
        }
        if (this.state.recordingFor === "observation") {
          observationAudio = recordedBlob.blob;
          observationURL = response;

          console.log(observationURL, observationAudio);
        }
        return {
          controlMeasureAudio,
          controlMeasureURL,
          observationAudio,
          observationURL,
        };
      });
    });
  };

  _setDataLoading = async (status) => {
    await this.setState((prevState) => {
      let { dataLoading } = prevState;
      dataLoading = status;
      return { dataLoading };
    });
  };

  _removeAudioFile = async (type) => {
    await this.setState((prevState) => {
      if (type === "observation") {
        prevState.observationAudio = "";
        prevState.observationURL = "";
        return prevState;
      }

      if (type === "control_measure") {
        prevState.controlMeasureAudio = "";
        prevState.controlMeasureURL = "";
        return prevState;
      }
    });
  };

  _onTimeChange = async (options) => {
    const { hour, minute, meridiem } = options;

    const time = `${hour}:${minute}:00`;
    const formattedTime = moment(time, "HH:mm:").format("hh:mm");

    await this.setState({
      selectedIncidentTime: formattedTime,
      selectedTimeMeridiem: meridiem,
    });
  };

  _reportType = () => {
    if (this.state.reportType == "nm") {
      return "NM";
    } else if (this.state.reportType == "ira") {
      return "IRA";
    } else {
      return "UA/UC";
    }
  };

  _clearForm = async () => {
    await this.setState((prevState) => {
      prevState.typeActList = TYPE_ACT;
      prevState.typeIncidentList = INCIDENT_TYPE;
      prevState.severityList = SEVERITY;
      prevState.serviceList = [];
      prevState.projectList = [];
      prevState.departmentList = [];
      prevState.contractorList = [];
      prevState.zoneList = [];
      prevState.locationList = [];
      prevState.hazardList = [];
      prevState.activityList = [];
      prevState.barrierList = [];
      prevState.subHazardList = [];
      prevState.voilatorPersonList = [];
      prevState.voilatorIdList = [];
      prevState.observationText = "";
      prevState.evidenceFileList = [];
      prevState.evidenceUrlList = [];
      prevState.selectedCompanyId =
        this.state.userData.designation_flag === 4
          ? prevState.selectedCompanyId
          : null;
      prevState.selectedServiceId =
        this.state.userData.designation_flag === 4
          ? prevState.selectedServiceId
          : null;
      prevState.selectedProjectId =
        this.state.userData.designation_flag === 4
          ? prevState.selectedProjectId
          : null;
      prevState.selectedDepartmentId = null;
      prevState.selectedContractorId = null;
      prevState.selectedZoneId = null;
      prevState.selectedLocationId = null;
      prevState.selectedTypeAct = null;
      prevState.tempFiles = [];
      prevState.selectedActivity = null;
      prevState.selectedSeverity = null;
      prevState.selectedBarrier = null;
      prevState.selectedHazardId = null;
      prevState.selectedSubHazardId = null;
      prevState.selectedIncidentTypeId = 1;

      prevState.selectedTargetDate = new Date();
      prevState.controlMeasure = "";
      prevState.resolveCheckbox = false;
      prevState.soiFormHidingField = {};
      prevState.nmFormHidingField = {};

      prevState.iraFormHidingField = {};
      prevState.companyError = false;
      prevState.serviceError = false;
      prevState.projectError = false;

      prevState.zoneError = false;
      prevState.departmentError = false;
      prevState.contractorError = false;
      prevState.locationError = false;

      prevState.typeActError = false;
      prevState.activityError = false;
      prevState.severityError = false;
      prevState.barrierError = false;
      prevState.hazardError = false;
      prevState.observationError = false;

      prevState.showRecorderModal = false;
      prevState.recordAudio = false;
      prevState.controlMeasureAudio = "";
      prevState.controlMeasureURL = "";
      prevState.observationAudio = "";
      prevState.observationURL = "";
      prevState.recordingFor = "observation";

      prevState.selectedIncidentTime = "10:00";
      prevState.selectedIncidentDate = new Date();
      prevState.selectedTimeMeridiem = "AM";
      prevState.personName = "";
      prevState.selectedSubActivity = null;
      prevState.subActivityList = [];
      prevState.subActivityError = false;

      prevState.projectAutoFill = {
        projectCategory: "",
        projectCategoryId: "",
        region: "",
        state: "",
        city: "",
      };

      return prevState;
    });
  };

  _continueReportingClearForm = async () => {
    await this.setState((prevState) => {
      prevState.typeActList = TYPE_ACT;
      prevState.typeIncidentList = INCIDENT_TYPE;
      prevState.severityList = SEVERITY;

      prevState.observationText = "";
      prevState.evidenceFileList = [];
      prevState.evidenceUrlList = [];
      prevState.selectedCompanyId = null;
      prevState.selectedServiceId = null;
      prevState.selectedProjectId = null;
      prevState.selectedDepartmentId = null;
      prevState.selectedContractorId = null;
      prevState.selectedZoneId = null;
      prevState.selectedLocationId = null;
      prevState.clearDropZone = false;
      prevState.selectedFile = "";
      prevState.divisionList = [];

      prevState.selectedActivity = null;
      prevState.selectedCategory = null;
      prevState.voilatorPersonList = [];
      prevState.soiFormHidingField = {};
      prevState.nmFormHidingField = {};
      prevState.voilatorIdList = [];
      prevState.serviceError = false;
      prevState.projectError = false;

      prevState.zoneError = false;
      prevState.departmentError = false;
      prevState.contractorError = false;
      prevState.locationError = false;

      prevState.activityError = false;
      prevState.categoryError = false;
      prevState.observationError = false;

      prevState.showRecorderModal = false;
      prevState.recordAudio = false;
      prevState.observationAudio = "";
      prevState.observationURL = "";
      prevState.recordingFor = "observation";
      prevState.tempFiles = [];
      prevState.selectedSubActivity = null;
      prevState.subActivityError = false;

      prevState.projectAutoFill = {
        projectCategory: "",
        projectCategoryId: "",
        region: "",
        state: "",
        city: "",
      };

      // clearing dropdown values
      prevState.serviceList = [];
      prevState.projectList = [];
      prevState.categoryList = [];
      prevState.departmentList = [];
      prevState.contractorList = [];
      prevState.zoneList = [];
      prevState.locationList = [];
      prevState.activityList = [];
      prevState.subActivityList = [];

      return prevState;
    });

    if (this.state.organisationSetting) {
      await this._fetchCompanyList();
    } else {
      await this._fetchServiceList();
    }
  };

  _addPersonName = async () => {
    await this.setState((prevState) => {
      let { personName, personNameList } = prevState;
      personNameList = [...personNameList, personName];
      personName = "";
      return { personName, personNameList };
    });
  };

  _removePersonName = async (position) => {
    await this.setState((prevState) => {
      let { personNameList } = prevState;
      personNameList.splice(position, 1);
      return { personNameList };
    });
  };
  getAlert = () => {
    alert(this.props.t("getAlertFromChild"));
  };
  _manageVoilatorState = (val, type) => {
    const { voilatorIdList, voilatorPersonList } = this.state;
    const temp = Array.from(type === 2 ? voilatorIdList : voilatorPersonList);
    temp.push(val);
    this.setState({
      [type === 2 ? "voilatorIdList" : "voilatorPersonList"]: temp,
      [type === 2 ? "voilatorId" : "voilatorPersonName"]: "",
    });
  };

  removeVoilator = (voilatorId, type = 1) => {
    const { voilatorIdList, voilatorPersonList } = this.state;
    const temp = [
      ...Array.from(type === 2 ? voilatorIdList : voilatorPersonList),
    ];
    temp.splice(temp.indexOf(voilatorId), 1);
    this.setState({
      [type === 2 ? "voilatorIdList" : "voilatorPersonList"]: temp,
    });
  };
  searchEmployee = async (inputString, callback) => {
    let userId = localStorage.getItem("userId");
    let token = localStorage.getItem("springToken");
    const requestParams = {
      auth_key: token,
      user_id: userId,
      search: inputString,
      projectId: this.state.selectedProjectId || this.state.projectId || null,
    };
    await axios
      .get(Url.userSearch, {
        params: requestParams,
        headers: {
          accept: "application/json",
        },
      })
      .then(async (response) => {
        if (response.data.status === 200) {
          callback(response.data);
          await this.setState({
            searchData: { ...this.state.searchData, ...response.data },
          });
        }
      })
      .catch((error) => {});
  };
  render() {
    const isOberserver = this.state.userData.designation_flag === 4;
    const { t } = this.props;
    return (
      <>
        {/* Data Loading  */}

        <div className="rd-content">
          <div className="rd-left-content">
            <div className="rd-box">
              <Row>
                <Col>
                  <div className="form-group">
                    {/* <label className="form-label">Image/Video</label> */}
                    <div className="padding-l-r">
                      <ReportDropZone
                        type="5"
                        uploadFile={this._uploadFile}
                        removeFile={this._removeUploadedFile} // Add this line
                        disabledPlaceHolder
                        clearDropZone={this.state.clearDropZone}
                      />
                    </div>
                  </div>

                  <div
                    className={`slds-form-element padding-l-r ${
                      this.state.observationError ? "slds-has-error" : ""
                    }`}
                  >
                    <div className="rd-box-head">
                      <div className="with-mic">
                        <label className="slds-form-element__label">
                          {t("observation")}
                          <abbr className="slds-required" title="required">
                            *{" "}
                          </abbr>
                        </label>
                      </div>
                      {this.state.observationURL ? (
                        <div className="audioPreviewer mt-2">
                          <AudioPlayer
                            src={this.state.observationURL}
                            showJumpControls={true}
                            layout="horizontal-reverse"
                            customVolumeControls={[]}
                            customAdditionalControls={[]}
                            style={{
                              width: "600px",
                            }}
                          />
                          <Button
                            variant="outline-primary"
                            onClick={() => this._removeAudioFile("observation")}
                          >
                            X
                          </Button>
                        </div>
                      ) : null}
                    </div>
                    <div className="slds-form-element__control">
                      <textarea
                        className="slds-textarea"
                        onChange={(event) =>
                          this._handleChange(event.target.value, "observation")
                        }
                        value={this.state.observationText}
                        placeholder={t("enterGoodActDescription")}
                      ></textarea>
                    </div>
                    {!!this.state.observationError && (
                      <div class="slds-form-element__help" id="error-01">
                        {requiredMessage}
                      </div>
                    )}
                  </div>
                  <div>
                    {!isOberserver ? (
                      <>
                        {this.state.organisationSetting && (
                          <Row>
                            <Col>
                              <CompanyList
                                optionList={this.state.companyList || []}
                                onChangeHandle={this._companyChangeHandle}
                                value={this.state.selectedCompanyId}
                                hasError={this.state.companyError}
                                searchable={true}
                                customSelectStyles={customSelectStyles}
                              />
                            </Col>
                          </Row>
                        )}
                        <Row>
                          <Col>
                            <ServiceList
                              optionList={this.state.serviceList}
                              onChangeHandle={this._serviceChangeHandle}
                              value={this.state.selectedServiceId}
                              hasError={this.state.serviceError}
                              searchable={true}
                              customSelectStyles={customSelectStyles}
                            />
                          </Col>
                          <Col>
                            <ProjectList
                              customPlaceHolder={"PPC"}
                              optionList={this.state.projectList}
                              onChangeHandle={this._projectChangeHandle}
                              value={this.state.selectedProjectId}
                              hasError={this.state.projectError}
                              searchable={true}
                              customSelectStyles={customSelectStyles}
                            />
                          </Col>
                        </Row>
                      </>
                    ) : null}
                  </div>
                  {this.state.organisationSetting && (
                    <div
                      className="mb-2"
                      style={{
                        border: "1px solid #eaeaea",
                        borderRadius: 8,
                        padding: 12,
                        margin: 12,
                      }}
                    >
                      <label className="slds-form-element__label">
                        Project Details
                      </label>
                      <div
                        style={{ display: "flex", flexWrap: "wrap", gap: 12 }}
                      >
                        <div
                          style={{ flex: "1 1 calc(50% - 6px)", minWidth: 0 }}
                        >
                          <label className="slds-form-element__label">
                            Project Category
                          </label>
                          <input
                            className="form-control"
                            disabled
                            value={
                              this.state.projectAutoFill.projectCategory || ""
                            }
                            placeholder="Auto-filled"
                          />
                        </div>
                        <div
                          style={{ flex: "1 1 calc(50% - 6px)", minWidth: 0 }}
                        >
                          <label className="slds-form-element__label">
                            Region
                          </label>
                          <input
                            className="form-control"
                            disabled
                            value={this.state.projectAutoFill.region || ""}
                            placeholder="Auto-filled"
                          />
                        </div>
                        <div
                          style={{ flex: "1 1 calc(50% - 6px)", minWidth: 0 }}
                        >
                          <label className="slds-form-element__label">
                            State
                          </label>
                          <input
                            className="form-control"
                            disabled
                            value={this.state.projectAutoFill.state || ""}
                            placeholder="Auto-filled"
                          />
                        </div>
                        <div
                          style={{ flex: "1 1 calc(50% - 6px)", minWidth: 0 }}
                        >
                          <label className="slds-form-element__label">
                            City
                          </label>
                          <input
                            className="form-control"
                            disabled
                            value={this.state.projectAutoFill.city || ""}
                            placeholder="Auto-filled"
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </Col>
                <Col>
                  <div>
                    <Row>
                      {this.state.userData?.div_dept == 1 && (
                        <Col sm={6}>
                          <CommonDropdown
                            title={t("division")}
                            optionList={this.state.divisionList}
                            onChangeHandle={this._divisionChangeHandle}
                            isRequired={true}
                            value={this.state.selectedDivisionId}
                            hasError={this.state.divisionError}
                            customSelectStyles={customSelectStyles}
                          />
                          {!!this.state.divisionError && (
                            <p className="inputErrorMsg">{requiredMessage}</p>
                          )}
                        </Col>
                      )}
                      <Col sm={6}>
                        <CommonDropdown
                          title={t("department")}
                          optionList={this.state.departmentList}
                          onChangeHandle={this._departmentChangeHandle}
                          isRequired={true}
                          value={this.state.selectedDepartmentId}
                          hasError={this.state.departmentError}
                          customSelectStyles={customSelectStyles}
                        />
                      </Col>
                      {!!(
                        this.state.showContractorDropdown &&
                        !Object.values(this.state.formHideField).includes(
                          "Contractor",
                        )
                      ) && (
                        <Col sm={6}>
                          <CommonDropdown
                            title={t("contractor")}
                            optionList={this.state.contractorList}
                            onChangeHandle={this._contractorChangeHandle}
                            isRequired={true}
                            value={this.state.selectedContractorId}
                            hasError={this.state.contractorError}
                            customSelectStyles={customSelectStyles}
                          />
                        </Col>
                      )}

                      {!!(
                        this.state.showZoneDropdown &&
                        !Object.values(this.state.formHideField).includes(
                          "Zone",
                        ) &&
                        !Object.values(this.state.formHideField).includes(
                          "zone",
                        )
                      ) && (
                        <Col sm={6}>
                          <CommonDropdown
                            title={t("zone")}
                            optionList={this.state.zoneList}
                            onChangeHandle={this._zoneChangeHandle}
                            isRequired={true}
                            value={this.state.selectedZoneId}
                            hasError={this.state.zoneError}
                            customSelectStyles={customSelectStyles}
                          />
                        </Col>
                      )}
                      {!!(
                        this.state.showLocationDropdown &&
                        !Object.values(this.state.formHideField).includes(
                          "Location",
                        ) &&
                        !Object.values(this.state.formHideField).includes(
                          "location",
                        )
                      ) && (
                        <Col sm={6}>
                          <CommonDropdown
                            title={t("location")}
                            optionList={this.state.locationList}
                            onChangeHandle={this._locationChangeHandle}
                            isRequired={true}
                            value={this.state.selectedLocationId}
                            hasError={this.state.locationError}
                            customSelectStyles={customSelectStyles}
                          />
                        </Col>
                      )}
                    </Row>
                  </div>
                  <div>
                    <Row>
                      <Col sm={6}>
                        <CommonDropdown
                          title={t("activity")}
                          optionList={this.state.activityList}
                          onChangeHandle={this._activityChangeHandle}
                          value={this.state.selectedActivity}
                          hasError={this.state.activityError}
                          customSelectStyles={customSelectStyles}
                          searchable={true}
                          customSelectStyles={customSelectStyles}
                          customStyle={true}
                        />
                      </Col>

                      {this.state.param_list?.subActivity &&
                        this.state.subActivityList?.length > 0 && (
                          <Col sm={6}>
                            <CommonDropdown
                              title="Sub-Activity"
                              optionList={this.state.subActivityList}
                              onChangeHandle={this._subActivityChangeHandle}
                              isRequired={true}
                              value={this.state.selectedSubActivity}
                              hasError={this.state.subActivityError}
                              searchable={true}
                              customSelectStyles={customSelectStyles}
                              customStyle={true}
                            />
                          </Col>
                        )}
                      <Col sm={6}>
                        <CommonDropdown
                          title={t("category")}
                          optionList={this.state.categoryList}
                          onChangeHandle={this._categoryChangeHandle}
                          value={this.state.selectedCategory}
                          hasError={this.state.categoryError}
                          searchable={true}
                          customSelectStyles={customSelectStyles}
                          customStyle={true}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={6} className="my-2">
                        {this.state.param_list?.personname && (
                          <div className="slds-form-element">
                            <label className="slds-form-element__label">
                              {t("goodPersonName")}
                            </label>
                            <div className="d-flex slds-form-element__control">
                              <input
                                className={`slds-input col-lg-11 border`}
                                value={this.state.voilatorPersonName}
                                style={{
                                  maxWidth: "11vw",
                                }}
                                onChange={(event) =>
                                  this.setState({
                                    voilatorPersonName: event.target.value,
                                  })
                                }
                                placeholder={t("enterGoodPersonName")}
                              />

                              <ErrorBlock
                                message={t(
                                  "enterAtLeastOneIncidentPerosonName",
                                )}
                              />

                              {/* <img src={require("assets/sls-icons/V2. New Development/ADD2.svg")} className=" ml-2 cursor-pointer svg-icons" onClick={() => this.state.voilatorPersonName !== "" && this._manageVoilatorState(this.state.voilatorPersonName, 1)} /> */}
                            </div>
                            {this.state.voilatorPersonList.map(
                              (personItem, personIndex) => (
                                <div
                                  className="d-flex justify-content-between mt-2"
                                  key={`person-${personIndex}`}
                                >
                                  <span>{personItem}</span>
                                  {/* <XCircle
                                  className="cursor-pointer"
                                  onClick={() =>
                                    this.removeVoilator(personIndex)
                                  }
                                /> */}
                                </div>
                              ),
                            )}
                          </div>
                        )}
                      </Col>
                      <Col sm={6} className="my-2">
                        {this.state.param_list?.personId && (
                          <div className="slds-form-element">
                            <label className="slds-form-element__label">
                              {t("goodPersonID")}
                            </label>
                            <div className="d-flex slds-form-element__control">
                              <input
                                className={`slds-input col-lg-11 ${
                                  this.state.incidentPersonNameError
                                    ? "border"
                                    : "border"
                                }`}
                                value={this.state.voilatorId}
                                style={{
                                  maxWidth: "11vw",
                                }}
                                onChange={(event) =>
                                  this.setState({
                                    voilatorId: event.target.value,
                                  })
                                }
                                placeholder={t("enterGoodPersonID")}
                              />

                              <ErrorBlock
                                message={t(
                                  "enterAtLeastOneIncidentPerosonName",
                                )}
                              />
                              <img
                                src={require("assets/sls-icons/V2. New Development/ADD2.svg")}
                                className=" ml-2 cursor-pointer svg-icons"
                                onClick={() => {
                                  if (
                                    this.state.voilatorPersonName !== "" &&
                                    this.state.voilatorId !== ""
                                  ) {
                                    this._manageVoilatorState(
                                      this.state.voilatorPersonName,
                                      1,
                                    );
                                    this._manageVoilatorState(
                                      this.state.voilatorId,
                                      2,
                                    );
                                  }
                                }}
                              />
                            </div>
                            {this.state.voilatorIdList.map(
                              (personItem, personIndex) => (
                                <div
                                  className="d-flex justify-content-between mt-2"
                                  key={`person-${personIndex}`}
                                >
                                  <span>{personItem}</span>
                                  <XCircle
                                    className="cursor-pointer"
                                    onClick={() => {
                                      this.removeVoilator(personIndex);
                                      this.removeVoilator(personIndex, 2);
                                    }}
                                  />
                                </div>
                              ),
                            )}
                          </div>
                        )}
                      </Col>
                    </Row>
                    <Row>
                      {!!(
                        this.state.selectedServiceId !== null &&
                        this.state.selectedProjectId !== null &&
                        !!this.state.param_list?.employeeMaster
                      ) && (
                        <Col sm={12} className="my-2">
                          <div className="slds-form-element">
                            <label className="slds-form-element__label">
                              {t("searchEmployee")}
                            </label>
                            <div className="w-100">
                              <AsyncSelect
                                isMulti={true}
                                cacheOptions
                                onChange={(data) => {
                                  const items = data?.map((el) => {
                                    return {
                                      ...el,
                                      employeeId: el?.clientEmployeeId,
                                      incident_person_id: el?.clientEmployeeId,
                                      incident_person_name: el?.label,
                                    };
                                  });
                                  this.setState({
                                    searchEmployeeUsers: data,
                                  });
                                }}
                                placeholder={t("searchEmployee")}
                                loadOptions={(input, callback) => {
                                  if (this.timeout) clearTimeout(this.timeout);
                                  this.timeout = setTimeout(() => {
                                    this.searchClientEmployee(input, (data) => {
                                      const items = data?.map((element) => {
                                        return {
                                          ...element,
                                          label: element?.displayName,
                                          value: element?.clientEmployeeId,
                                        };
                                      });

                                      callback(items);
                                    });
                                  }, 1000);
                                }}
                              />
                            </div>
                          </div>
                        </Col>
                      )}
                      {!!(
                        this.state.selectedServiceId !== null &&
                        this.state.selectedProjectId !== null &&
                        (!!this.state.param_list?.activeUser ||
                          !!this.state.param_list?.employeeSearch)
                      ) && (
                        <Col sm={12} className="my-2">
                          <div className="slds-form-element">
                            <label className="slds-form-element__label">
                              {this.state.reportType == "ira"
                                ? t("searchEmployee")
                                : t("activeUser")}
                            </label>
                            <div className="w-100">
                              <AsyncSelect
                                isMulti
                                cacheOptions
                                onChange={(data) => {
                                  const items = data?.map((el) => {
                                    return {
                                      ...el,
                                      incident_person_id: el?.value,
                                      incident_person_name: el?.label,
                                    };
                                  });
                                  this.setState({
                                    searchFiledUsers: items,
                                  });
                                }}
                                placeholder={
                                  this.state.reportType == "ira"
                                    ? t("searchEmployee")
                                    : t("activeUser")
                                }
                                loadOptions={(input, callback) => {
                                  if (this.timeout) clearTimeout(this.timeout);
                                  this.timeout = setTimeout(() => {
                                    this.searchActiveUser(input, (data) => {
                                      const items = data?.data.map(
                                        (element) => {
                                          return {
                                            ...element,
                                            label: element?.name,
                                            value: element?.id,
                                          };
                                        },
                                      );
                                      callback(items);
                                    });
                                  }, 1000);
                                }}
                              />
                            </div>
                          </div>
                        </Col>
                      )}
                    </Row>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </div>

        <Modal
          show={this.state.showRecorderModal}
          dialogClassName="modal-90w"
          aria-labelledby="Voice Recording"
          onHide={() => this._showRecorder(false)}
          className="recordingModal"
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>{t("record")}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <div>
                <Button onClick={this.startRecording} className="red-btn">
                  <Mic />
                </Button>
                <Button onClick={this.stopRecording} className="gray-btn">
                  <MicOff />
                </Button>
              </div>
              <div className="obervationRecording"></div>
            </div>
          </Modal.Body>
        </Modal>
        <Modal
          show={this.state.showRecorderModal}
          dialogClassName="modal-90w"
          aria-labelledby="Voice Recording"
          onHide={() => this._showRecorder(false)}
          className="recordingModal"
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body>
            <div className="obervationRecording">
              <ReactMic
                record={this.state.recordAudio}
                className="sound-wave"
                onStop={this.onStop}
                strokeColor="#000000"
                mimeType="audio/mp3"
                backgroundColor="#FF4081"
              />
            </div>

            <div className="modal-footer-btn">
              <Button onClick={this.startRecording} className="red-btn">
                <Mic /> {t("startRecording")}
              </Button>
              <Button onClick={this.stopRecording} className="gray-btn">
                <MicOff /> {t("stopRecording")}
              </Button>
            </div>
          </Modal.Body>
        </Modal>

        <Modal
          centered
          show={this.state.sucesssPopup}
          className="recordingModal"
          onHide={this._closeSuccessPopup}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Body className="text-center">
            <img
              className="submit-img"
              // src={require("assets/images/submit.png")}
              src={SubmitImage}
              alt="submit_image"
            />
            <p className="report-submit-text"> {t("thankYouForReporting")} </p>
            <p className="report-submit-text"> {t("youHaveReported")} </p>
            <p className="report-submit-text">
              {this.state.reportNumber || 0} {t("goodPracticesTillToday")}
            </p>
            <div className="modal-footer-btn">
              <button
                type="submit"
                className="red-btn"
                onClick={this._closeSuccessPopup}
              >
                {t("gotoDashboardAUC")}
              </button>
              <button
                type="submit"
                className="red-btn"
                onClick={this._continueReporting}
              >
                {t("continueReportingAUC")}
              </button>
            </div>
          </Modal.Body>
        </Modal>

        {this.state.showLowStoragePopup ? (
          <LowSpace
            message={this.state.lowStorageMessage}
            handleLowSpace={this._handleLowSpace}
          />
        ) : null}
      </>
    );
  }
}

export default compose(
  withRouter,
  withTranslation(["report", "util"]),
)(GPReport);
